import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Hammer, BellRing } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { api, dateRange } from '../../utils/upgradesApi';
import { FLAG_LABELS } from '../../constants/upgrades';
import './upgrades.css';

const cardStyle = { backgroundColor: '#FFF', borderRadius: '12px', border: '1px solid #E0E0E0', padding: '20px' };
const titleStyle = { fontSize: '18px', fontWeight: 600, color: '#333', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' };

const Row = ({ job, hint }) => (
  <Link to={`/upravy/${job.id}`} className="upg-mini">
    <span style={{ minWidth: 0, flex: '1 1 160px' }}>
      <strong style={{ fontSize: 14, color: '#333' }}>{job.customer_name}</strong>
      <span style={{ display: 'block', fontSize: 12, color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{job.number} · {hint}</span>
    </span>
    <StatusBadge status={job.status} />
  </Link>
);

// Dashboard: the next trips and the jobs that need attention (expired quotes, waiting for a date, overdue…).
const UpgradeDashboardCards = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api('/summary').then(setData).catch(() => setData({ upcoming: [], attention: [] })); }, []);
  if (!data) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '16px', marginBottom: '24px' }}>
      <div style={cardStyle}>
        <h2 style={titleStyle}><Hammer size={20} color="#E53935" /> Nadcházející výjezdy</h2>
        {data.upcoming.length === 0 ? <p style={{ color: '#999', margin: 0, fontSize: 14 }}>Žádný naplánovaný výjezd.</p> : (
          <div style={{ display: 'grid', gap: 8 }}>
            {data.upcoming.map((j) => <Row key={j.id} job={j} hint={`${dateRange(j)}${j.crew.length ? ` · ${j.crew.map((c) => c.name).join(', ')}` : ''}`} />)}
          </div>
        )}
      </div>
      <div style={cardStyle}>
        <h2 style={titleStyle}><BellRing size={20} color="#E53935" /> Úpravy k vyřízení</h2>
        {data.attention.length === 0 ? <p style={{ color: '#999', margin: 0, fontSize: 14 }}>Nic nečeká na vaši akci.</p> : (
          <div style={{ display: 'grid', gap: 8 }}>
            {data.attention.map((j) => <Row key={j.id} job={j} hint={j.flags.filter((f) => FLAG_LABELS[f]).map((f) => FLAG_LABELS[f]).join(' · ')} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default UpgradeDashboardCards;
